

























import Vue, { PropOptions } from 'vue';
import type { LogosItem } from '~/components/storyblok/LogosItem.vue';

export type LogosSection = Blok & {
  title?: string;
  logos: LogosItem[];
  columnsMobile?: number;
  inlineTitle: boolean;
  withoutDecoration: boolean;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<LogosSection>,
  },
  computed: {
    cssVars(): CSSVars {
      return {
        '--columns-mobile': `repeat(${this.blok?.columnsMobile}, 1fr)`,
        '--border-decoration': this.blok?.withoutDecoration
          ? 'none'
          : this.$store.state.colorMode === 'light'
          ? '2px solid hsl(0, 0%, 80%)'
          : '2px solid hsl(0, 0%, 40%)',
      };
    },
  },
});
